var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFall1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192.3 75.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f60;}.cls-2{fill:#b2b2b2;}.cls-3{fill:#575656;}.cls-4{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 192.3,
    height: 75.53
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 155.9,
    y: 23.77,
    width: 26.3,
    height: 11.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 155.9,
    y: 40.87,
    width: 26.3,
    height: 11.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.4,52.77l-.6-4c3.4-.5,6.9-1.1,10.7-1.7,26.5-4.3,66.5-10.9,161.1-10.9v4c-94.3,0-134.1,6.5-160.5,10.9-3.7,.6-7.3,1.2-10.7,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.2,13.17h-1v2.3h-.7c-.7,0-1.2-.1-1.5-.2-.3-.2-.4-.4-.4-.8v-1.5h-1l-.1,1.6c0,.8,.2,1.3,.6,1.6,.4,.3,1.2,.5,2.3,.5h.7v1h1v-1h6.8v-1.2h-6.8l.1-2.3h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "92.3 14.27 88.9 14.27 88.9 7.07 87.6 7.07 87.6 15.47 92.3 15.47 92.3 14.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.3,
    y: 52.97,
    width: 189,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.5,
    y: 17.97,
    width: 153,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.3,
    y: 16.47,
    width: 5.2,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.4,
    y: 15.17,
    width: 1,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 149.3,
    y: 16.47,
    width: 5.2,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 156.3,
    y: 15.17,
    width: 1,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 188.8,
    y: 14.57,
    width: 1,
    height: 47.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 187.5,
    y: 55.37,
    width: 3.7,
    height: 5.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 187.5,
    y: 31.37,
    width: 3.7,
    height: 5.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13 35.27 13 31.17 17.1 31.17 17.1 29.67 13 29.67 13 26.07 17.9 26.07 17.9 24.57 11.2 24.57 11.2 35.27 13 35.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3.3 24.47 3.3 36.07 0 35.17 4.1 45.77 8.3 35.17 5 36.07 5 24.47 3.3 24.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 177.4,
    y: 37.97,
    width: 14.8,
    height: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFall1);
export default __webpack_public_path__ + "static/media/Fall1.b12cf9745377a95ed26378fe8a394647.svg";
export { ForwardRef as ReactComponent };